import * as React from 'react';
import { AgenciesList } from './AgenciesList';
import { EditAgencyForm } from './EditAgencyForm';
import { Routes, Route, useParams, useNavigate } from 'react-router-dom';
import { NotFound } from '../NotFound';
import { RoleSection } from '../../components/RoleSection';
import { NotAllowed } from '../NotAllowed';
import { Agency } from './Agency';
import { AppSection } from '../../components/AppSection';

function ViewAgencyRoute() {
    const params = useParams();
    return (<Agency identifier={params.identifier!} />);
}

function EditAgencyRoute() {
    const params = useParams();
    const navigate = useNavigate();
    return (<EditAgencyForm history={{ push: (to: string) => navigate(to) }} identifier={params.identifier!} />);
}

function CreateAgencyRoute() {
    const navigate = useNavigate();
    return (<EditAgencyForm history={{ push: (to: string) => navigate(to) }} />);
}

export class Agencies extends React.Component<any,any>{

    public render(){

        return (<React.Fragment>
            <AppSection section="agencies" />
            <RoleSection role="admin" render={(forbidden)=>(
                <Routes>
                    {forbidden && <Route path="*" element={<NotAllowed />} />}
                    <Route path="create" element={<CreateAgencyRoute />} />
                    <Route path=":identifier/edit" element={<EditAgencyRoute />} />
                    <Route path=":identifier" element={<ViewAgencyRoute />} />
                    <Route path="" element={<AgenciesList />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            )} />
        </React.Fragment>)
    }
}
